<template>
  <a
    v-if="userGuideUrl"
    :href="userGuideUrl"
    target="_blank"
    rel="noopener noreferrer"
    class="user-guide-btn cursor-pointer mr-3 flex items-center"
    :title="$t('UserGuide')"
  >
    <feather-icon icon="HelpCircleIcon" svg-classes="h-7 w-7" />
  </a>
</template>

<script>
export default {
  name: 'user-guide-button',
  computed: {
    userGuideUrl() {
      const urls = this.resolveUrls();
      if (!urls) return null;

      const locale = this.$i18n.locale;
      if (locale.startsWith('fr')) return urls.fr || urls.en || null;
      return urls.en || urls.fr || null;
    }
  },
  methods: {
    resolveUrls() {
      if (this.containsUserGuide(this.$route.meta)) {
        return this.$route.meta.userGuideUrl;
      }

      // Walk the breadcrumb in reverse (closest parent first) to find a userGuideUrl
      const breadcrumb = (this.$route.meta && this.$route.meta.breadcrumb) || [];
      for (let i = breadcrumb.length - 1; i >= 0; i--) {
        const url = breadcrumb[i].url;
        if (!url || url === '/') continue;
        const resolved = this.$router.resolve(url);
        if (resolved && resolved.route && this.containsUserGuide(resolved.route.meta)) {
          return resolved.route.meta.userGuideUrl;
        }
      }

      return null;
    },
    containsUserGuide(meta) {
      return meta && meta.userGuideUrl && (meta.userGuideUrl.en || meta.userGuideUrl.fr);
    }
  }
}
</script>

<style scoped>
.user-guide-btn {
  color: #63666A;
}
</style>
